<template>
    <div class="main">
        <div class="home shadow">
            <div class="innerPopup">
                <div class="popup">
                    <div class="logoText">
                        <img src="../../assets/img/saveSuccess.png" class="successLogo">
                        <span class="submitSuccessText">提交成功!</span>
                    </div>
                    <el-form :model="form" class="applySubmitId">
                        <div class="applySubmitForm">
                            <el-row>
                                <el-col>
                                    <el-form-item label-width="100px" label="申请索引号">
                                        <el-input v-model="form.id"/>
                                        <span class="popupText">注：申请索引号用于查询、下载、补正申请信息，请务必保存。</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="footer">
                            <el-button type="primary" @click="back('政府信息公开申请')">返回</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    certificateNo: '',
                    id: ''
                }
            }
        },
        mounted() {
            this.getParams()
        },
        methods: {
            getParams() {
                const id1 = this.$route.query.saveId
                this.form.id = id1
            },

            back(name) {
                this.$router.push({
                    path: '/',
                    query: {
                        name: name,
                        id: 0
                    }
                })
            },

            route_goFun(name) {
                this.$router.push({
                    path: '/',
                    query: {
                        name: name,
                        id: 1
                    }
                })
            }
        }
    }

</script>
<style>

</style>
